import { createSlice } from '@reduxjs/toolkit';
import { fetchWithDriverOrder, fetchOrderBookingZoneById } from './actions';

const initialState = {
  data: {},
  bookingZones: {},
  page: 1,
  status: 'idle', //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

export const withDriverOrder = createSlice({
  name: 'withDriverOrder',
  initialState,
  reducers: {
    // reducers goes here
    saveVehicleData: (state, action) => {
      return { ...state, vehicleList: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWithDriverOrder.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchWithDriverOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(fetchWithDriverOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchOrderBookingZoneById.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchOrderBookingZoneById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(fetchOrderBookingZoneById.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.bookingZones = action.payload;
      });
  },
});

export const { saveVehicleData } = withDriverOrder.actions;

export default withDriverOrder.reducer;
